import withAppInsights from 'Core_Helpers/AppInsights';

// This wraps the component with Microsoft's ai tracker
const AppInsightsAiTracking = ({ children }) => {
  return children;
};

export default withAppInsights(AppInsightsAiTracking);
